module.exports = __webpack_public_path__ + "static/img/AA-3.8ec6ea68.png";